<template>
    <div v-if="count > 10">
        <div class="pageLayout">

            <div class="pageItem" @click="goFrist">
                < </div>

                    <div v-for="(item, index) in listPage" :class="item.display == true ? 'pageItem_check' : 'pageItem'"
                        :key="index" @click="pageClick(item.value)">

                        <div>
                            {{ item.value }}
                        </div>

                    </div>

                    <div class="pageItem" @click="goLastPage"> > </div>

            </div>

            <div class="line"></div>
        </div>
</template>
<script>
import { } from '../util/comment_mock.js';


export default {
    name: 'pageView',
    emits: ['pageCheck'],
    props: {
        count: {
            default: 0,
        },
    },
    components: {},
    data() {
        return {
            show: false,
            // count: 999,
            pageNumber: 0,
            listPage: []
        }
    },

    watch: {
        count: function (val) {
            if (val == 0) {
                this.show = false;
            } else {
                this.show = true;
            }
            this.initPageView();
        },
    },

    methods: {
        initPageView() {
            this.pageNumber = Math.ceil(this.count / 10);
            // console.log(this.pageNumber + "======");
            this.notifyPageView(1);
        },
        isNumber(value) {
            return typeof value === 'number';
        },
        pageClick(checkIndex) {
            if (this.isNumber(checkIndex)) {
                this.$emit("pageCheck", checkIndex);
                this.notifyPageView(checkIndex);
            }
        },

        notifyPageView(checkIndex) {
            // console.log(checkIndex + "====");
            this.listPage = [];
            if (this.pageNumber < 8) {
                this.buildData_8(checkIndex);
            } else {
                if (this.pageNumber - checkIndex > 5) {
                    this.buildData_max(checkIndex);
                } else {
                    this.build_ls_5(checkIndex);
                }
            }
        },

        buildData_8(checkIndex) {
            for (var i = 1; i <= this.pageNumber; i++) {
                if (checkIndex == i) {
                    this.listPage.push({
                        "display": true,
                        "value": i,
                    });
                } else {
                    this.listPage.push({
                        "display": false,
                        "value": i,
                    });
                }

            }

        },

        build_ls_5(checkIndex) {

            for (var x = 1; x < 4; x++) {
                this.listPage.push({
                    "display": false,
                    "value": x,
                });
            }

            this.listPage.push({
                "display": false,
                "value": "⋯",
            });

            for (var i = checkIndex - 1; i <= this.pageNumber; i++) {
                if (checkIndex == i) {
                    this.listPage.push({
                        "display": true,
                        "value": i,
                    });
                } else {
                    this.listPage.push({
                        "display": false,
                        "value": i,
                    });
                }

            }

        },




        buildData_max(checkIndex) {

            for (var i = checkIndex; i <= checkIndex + 1; i++) {
                if (checkIndex == i) {
                    this.listPage.push({
                        "display": true,
                        "value": i,
                    });
                } else {
                    this.listPage.push({
                        "display": false,
                        "value": i,
                    });
                }

            }
            this.listPage.push({
                "display": false,
                "value": "⋯",
            });
            for (var j = this.pageNumber - 2; j <= this.pageNumber; j++) {

                if (checkIndex == j) {
                    this.listPage.push({
                        "display": true,
                        "value": j,
                    });
                } else {
                    this.listPage.push({
                        "display": false,
                        "value": j,
                    });
                }

            }
        },

        goFrist() {
            this.$emit("pageCheck", 1);
            this.notifyPageView(1);
        },
        goLastPage() {
            this.$emit("pageCheck", this.pageNumber);
            this.notifyPageView(this.pageNumber);
        },

    },

    mounted() {
        this.initPageView();
    },


}

</script>

<style scoped>
.pageLayout {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
}

.pageItem {
    border: 1px solid #D9D9D9;
    width: 26px;
    height: 26px;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    margin: 2px;
    color: #333333;
    align-items: center;
    text-align: center;
    justify-content: center;
    display: flex;
    border-radius: 4px;
    cursor: pointer;
}

.pageItem_check {
    border: 1px solid #f1b308;
    width: 26px;
    height: 26px;
    font-family: Roboto;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    margin: 2px;
    color: #f1b308;
    align-items: center;
    text-align: center;
    justify-content: center;
    display: flex;
    cursor: pointer;
}
</style>